import { ChangeDetectorRef, Component, OnInit, ViewChild, AfterViewInit, OnDestroy, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { GlobalConfig, ToastrService } from 'ngx-toastr';
import { v4 as uuidv4 } from 'uuid';
import { environment } from 'environments/environment.prod';
import * as feather from 'feather-icons';
import flatpickr from 'flatpickr';
import { French } from 'flatpickr/dist/l10n/fr';

import {HeaderService} from "../../../../../services/header/header.service";
import {BehaviorSubject} from "rxjs";
import {TresorerieService} from "../../../../../services/tresorerie/tresorerie.service";
import {ClientService} from "../../../../../services/Client/client.service";
import {Client} from "../../../../../models/client";
import {BanqueService} from "../../../../../services/Banque/banque.service";
import {Banque} from "../../../../../models/banque.model";
import {ChequeTraite} from '../../../../../models/Tresorerie/ChequeTraite';

export interface ArchiveItem {
    reference: string;
    clientName: string;
    email: string;
    gender: string;
    revenue: string;
    matricule: string;
    phoneNumbers?: string[];
    addresses?: { addressType: string; pays: string; region: string; codePostal: string; adresse: string }[];
    type?: string;
    authorizedOverdraft?: string;
    priceType?: string;
    paymentPeriod?: string;
    paymentPeriodValue?: number;
    customPrices?: { id: string; name: string; value: number }[];
}
@Component({
  selector: 'app-add-cheque',
  templateUrl: './add-cheque.component.html',
  styleUrls: ['./add-cheque.component.scss']
})
export class AddChequeComponent implements OnInit, AfterViewInit, OnDestroy {

    steps: string[] = ['Type d’opération', 'Moyen de paiement', 'Sélection du client', 'Détails du paiement', 'Informations complémentaires', ' Terminé'];
    currentStep: number = 0;
    productData: any = {
        type: '',
        typeOperation: '',
        typePaiementStep: '',
        typePaiement: '',
        paymentPeriod: '',
        paymentPeriodValue: 1,
        customPrices: [],
        porteur: '',
        banque_id: null,
        numero_cheque: '',
        date_echeance: '',
        date_reglement: '',
        note: '',
        solde_type: 'secondaire',
        client_id: null
    };
    numArray: number[] = [0];
    addressArray: { addressType: string; pays: string; region: string; codePostal: string; adresse: string }[] = [
        { addressType: '', pays: '', region: '', codePostal: '', adresse: '' }
    ];
    isStep1Valid: boolean = false;
    isStep2Valid: boolean = false;
    isStep3Valid: boolean = true;
    isStep4Valid: boolean = true;
    isStep5Valid: boolean = true;
    showStep1Error: boolean = false;
    showStep2Error: boolean = false;
    mode: 'add' | 'edit' = 'add';
    file: string = environment.file_url;
    private options: GlobalConfig;
    showPriceModal: boolean = false;
    newPriceName: string = '';
    newPriceValue: number = 0;
    isLoading: boolean = false;
    showErrorOnce: boolean = false;
    hasAddedPhone: boolean = false;
    hasAddedAddress: boolean = false;
    stationId: number = 0;
    userId: number = 0;
    clientId: number | null = null;
    clients: Client[] = [];
    isLoadingClients: boolean = false;
    banques: Banque[] = [];
    isLoadingBanques: boolean = false;
    soldePrimaire: string = '0,000';
    soldeSecondaire: string = '0,000';
    client = {
        gender: '',
        fullName: '',
        identifier: '',
        email: '',
        phones: [{ type: '', number: '' }] as { type: string; number: string }[],
        adresse: '',
        addressType: ''
    };

    @ViewChild('step2Form') step2Form: NgForm;
    @ViewChild('step3Form') step3Form: NgForm;
    @ViewChild('step4Form') step4Form: NgForm;
    @ViewChild('dateEcheanceInput') dateEcheanceInput!: ElementRef<HTMLInputElement>;
    @ViewChild('dateReglementInput') dateReglementInput!: ElementRef<HTMLInputElement>;
    
    private dateEcheancePicker: flatpickr.Instance | null = null;
    private dateReglementPicker: flatpickr.Instance | null = null;

    constructor(
        private cd: ChangeDetectorRef,
        private route: ActivatedRoute,
        private router: Router,
        private toastr: ToastrService,
        private headerService: HeaderService,
        private tresorerieService: TresorerieService,
        private clientService: ClientService,
        private banqueService: BanqueService
    ) {
        this.options = this.toastr.toastrConfig;
    }
    private tableData = new BehaviorSubject<ArchiveItem[]>([]);
    ngOnInit(): void {
        this.headerService.setConfig({
            title: 'Cheque et traite',
            buttons:[],
        });

        this.loadUserData();
        setTimeout(() => {
            this.loadClients();
            this.loadBanques();
            this.loadSoldes();
        }, 100);

        const navigation = this.router.getCurrentNavigation();
        if (navigation?.extras?.state?.client) {
            this.mode = navigation.extras.state.isEditMode ? 'edit' : 'add';
            const clientData = navigation.extras.state.client as ArchiveItem;
            this.populateForm(clientData);
            this.currentStep = 1;
        } else {
            this.mode = this.route.snapshot.url.some((seg) => seg.path === 'edit') ? 'edit' : 'add';
            if (this.mode === 'edit') {
                this.currentStep = 1;
            }
        }
        this.updateNumArray();
        this.validateStep3();
        this.cd.markForCheck();
        this.cd.detectChanges();
        this.refreshFeatherIcons();

    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.initializeDatePickers();
        }, 300);
    }

    private initializeDatePickers(): void {
        if (this.dateEcheancePicker) {
            this.dateEcheancePicker.destroy();
            this.dateEcheancePicker = null;
        }
        if (this.dateReglementPicker) {
            this.dateReglementPicker.destroy();
            this.dateReglementPicker = null;
        }
        const parseDate = (dateStr: string | null): Date | null => {
            if (!dateStr) return null;
            if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
                return new Date(dateStr + 'T00:00:00');
            }
            const parsed = new Date(dateStr);
            return isNaN(parsed.getTime()) ? null : parsed;
        };
        if (this.dateEcheanceInput?.nativeElement) {
            const defaultDate = parseDate(this.productData.date_echeance);
            this.dateEcheancePicker = flatpickr(this.dateEcheanceInput.nativeElement, {
                locale: French,
                dateFormat: 'Y-m-d',
                allowInput: true,
                clickOpens: true,
                defaultDate: defaultDate || undefined,
                onChange: (selectedDates, dateStr) => {
                    if (dateStr) {
                        this.productData.date_echeance = dateStr;
                        this.validateStep5();
                        this.cd.detectChanges();
                    }
                }
            });
        }
        if (this.dateReglementInput?.nativeElement) {
            const defaultDate = parseDate(this.productData.date_reglement);
            this.dateReglementPicker = flatpickr(this.dateReglementInput.nativeElement, {
                locale: French,
                dateFormat: 'Y-m-d',
                allowInput: true,
                clickOpens: true,
                defaultDate: defaultDate || undefined,
                onChange: (selectedDates, dateStr) => {
                    if (dateStr) {
                        this.productData.date_reglement = dateStr;
                        this.validateStep5();
                        this.cd.detectChanges();
                    }
                }
            });
        }
    }

    ngOnDestroy(): void {
        if (this.dateEcheancePicker) {
            this.dateEcheancePicker.destroy();
        }
        if (this.dateReglementPicker) {
            this.dateReglementPicker.destroy();
        }
    }

    private loadUserData(): void {
        try {
            const userJson = localStorage.getItem('currentUser');
            if (userJson) {
                const user = JSON.parse(userJson);
                this.userId = user?.id ? Number(user.id) : 0;
                this.clientId = user?.client_id ? Number(user.client_id) : null;
                const station = user?.stations?.[0];
                this.stationId = station?.id ? Number(station.id) : 0;
                
                console.log('📋 [AddChequeComponent] Données utilisateur chargées:');
                console.log('   - User ID:', this.userId);
                console.log('   - Station ID:', this.stationId);
                console.log('   - Client ID:', this.clientId);
                
                if (!this.stationId || !this.userId) {
                    console.error('⚠️ [AddChequeComponent] Station ID ou User ID manquant!');
                    this.toastr.warning('Données utilisateur incomplètes. Veuillez vous reconnecter.', 'Attention');
                }
            } else {
                console.error('⚠️ [AddChequeComponent] Aucune donnée utilisateur trouvée dans localStorage');
                this.toastr.error('Session expirée. Veuillez vous reconnecter.', 'Erreur');
            }
        } catch (error) {
            console.error('❌ [AddChequeComponent] Erreur lors de la récupération des données utilisateur:', error);
            this.toastr.error('Erreur lors de la récupération des données utilisateur', 'Erreur');
        }
    }

    private loadClients(): void {
        if (!this.stationId) {
            console.warn('⚠️ [AddChequeComponent] Station ID non disponible pour charger les clients');
            return;
        }

        this.isLoadingClients = true;
        this.clientService.getActiveClient(this.stationId, 1, 100).subscribe({
            next: (response) => {
                this.isLoadingClients = false;
                this.clients = response.data || [];
                console.log('✅ [AddChequeComponent] Clients chargés:', this.clients.length);
                this.cd.detectChanges();
            },
            error: (error) => {
                this.isLoadingClients = false;
                console.error('❌ [AddChequeComponent] Erreur lors du chargement des clients:', error);
                this.clients = [];
                this.toastr.error('Erreur lors du chargement des clients', 'Erreur');
                this.cd.detectChanges();
            }
        });
    }

    private loadBanques(): void {
        if (!this.stationId) {
            console.warn('⚠️ [AddChequeComponent] Station ID non disponible pour charger les banques');
            setTimeout(() => {
                if (this.stationId) {
                    this.loadBanques();
                }
            }, 200);
            return;
        }

        console.log('🏦 [AddChequeComponent] Chargement des banques pour station_id:', this.stationId);

        this.isLoadingBanques = true;
        this.banqueService.getBanques(this.stationId).subscribe({
            next: (response: any) => {
                this.isLoadingBanques = false;
                console.log('🏦 [AddChequeComponent] Réponse API banques:', response);
                if (response && response.banques && Array.isArray(response.banques)) {
                    this.banques = response.banques;
                } else if (response && response.data && Array.isArray(response.data)) {
                    this.banques = response.data;
                } else if (Array.isArray(response)) {
                    this.banques = response;
                } else {
                    this.banques = [];
                    console.warn('⚠️ [AddChequeComponent] Format de réponse banques non reconnu');
                }
                
                console.log('✅ [AddChequeComponent] Banques chargées:', this.banques.length);
                this.cd.detectChanges();
            },
            error: (error) => {
                this.isLoadingBanques = false;
                console.error('❌ [AddChequeComponent] Erreur lors du chargement des banques:', error);
                this.banques = [];
                this.toastr.error('Erreur lors du chargement des banques', 'Erreur');
                this.cd.detectChanges();
            }
        });
    }

    private loadSoldes(): void {
        if (!this.stationId) {
            console.warn('⚠️ [AddChequeComponent] Station ID non disponible pour charger les soldes');
            setTimeout(() => {
                if (this.stationId) {
                    this.loadSoldes();
                }
            }, 200);
            return;
        }

        console.log('💰 [AddChequeComponent] Chargement des soldes pour station_id:', this.stationId);

        this.tresorerieService.getSoldesByStation(this.stationId).subscribe({
            next: (response: any) => {
                console.log('💰 [AddChequeComponent] Réponse API soldes:', response);
                
                let soldes: any[] = [];
                if (Array.isArray(response)) {
                    soldes = response;
                } else if (response && response.data) {
                    if (Array.isArray(response.data)) {
                        soldes = response.data;
                    } else if (response.data.soldes && Array.isArray(response.data.soldes)) {
                        soldes = response.data.soldes;
                    }
                } else if (response && response.success && response.data) {
                    soldes = Array.isArray(response.data) ? response.data : [response.data];
                }

                const soldePrimaire = soldes.find((s: any) => s.type_solde === 'primaire');
                const soldeSecondaire = soldes.find((s: any) => s.type_solde === 'secondaire');

                if (soldePrimaire) {
                    const montant = parseFloat(soldePrimaire.montant_total || '0');
                    this.soldePrimaire = montant.toLocaleString('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
                    console.log('✅ [AddChequeComponent] Solde primaire chargé:', this.soldePrimaire);
                } else {
                    this.soldePrimaire = '0,000';
                    console.warn('⚠️ [AddChequeComponent] Solde primaire non trouvé');
                }
                
                if (soldeSecondaire) {
                    const montant = parseFloat(soldeSecondaire.montant_total || '0');
                    this.soldeSecondaire = montant.toLocaleString('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
                    console.log('✅ [AddChequeComponent] Solde secondaire chargé:', this.soldeSecondaire);
                } else {
                    this.soldeSecondaire = '0,000';
                    console.warn('⚠️ [AddChequeComponent] Solde secondaire non trouvé');
                }

                this.cd.detectChanges();
            },
            error: (error) => {
                console.error('❌ [AddChequeComponent] Erreur lors du chargement des soldes:', error);
                this.soldePrimaire = '0,000';
                this.soldeSecondaire = '0,000';
                this.cd.detectChanges();
            }
        });
    }

    populateForm(clientData: ArchiveItem): void {

        this.client = {
            gender: clientData.gender || '',
            fullName: clientData.clientName || '',
            identifier: clientData.reference || '',
            email: clientData.email || '',
            phones: clientData.phoneNumbers?.map(number => ({ type: 'Mobile', number })) || [{ type: '', number: '' }],
            adresse: '',
            addressType: ''
        };
        this.productData = {
            type: clientData.type || '',
            authorizedOverdraft: clientData.authorizedOverdraft || '',
            priceType: clientData.priceType || '',
            paymentPeriod: clientData.paymentPeriod || '',
            paymentPeriodValue: clientData.paymentPeriodValue || 1,
            customPrices: clientData.customPrices || []
        };
        this.addressArray = clientData.addresses?.length
            ? clientData.addresses.map(addr => ({ ...addr }))
            : [{ addressType: '', pays: '', region: '', codePostal: '', adresse: '' }];
        this.hasAddedPhone = this.client.phones.length > 1;
        this.hasAddedAddress = this.client.adresse.length > 1;
        this.updateNumArray();
        this.validateStep1();
        this.validateStep2();
        this.validateStep3();
        this.validateStep4();
        this.validateStep5();
    }

    refreshFeatherIcons(): void {
        setTimeout(() => {
            feather.replace();
            this.cd.detectChanges();
        }, 0);
    }

    private updateNumArray(): void {
        this.numArray = this.client.phones.length > 0 ? this.client.phones.map((_, i) => i) : [];

    }

    onTimelineStepSelected(stepIndex: number): void {
        if (stepIndex >= 0 && stepIndex < this.steps.length && this.isPreviousStepsValid(stepIndex)) {
            this.currentStep = stepIndex;
            this.onStepChange();
        }
    }

    isPreviousStepsValid(stepIndex: number): boolean {
        for (let i = 0; i < stepIndex; i++) {
            switch (i) {
                case 0:
                    if (!this.isStep1Valid) return false;
                    break;
                case 1:
                    if (!this.isStep2Valid) return false;
                    break;
                case 2:
                    if (!this.isStep3Valid) return false;
                    break;
                case 3:
                    if (!this.isStep4Valid) return false;
                    break;
            }
        }
        return true;
    }

    nextStep(): void {
        if (this.isCurrentStepValid() && this.currentStep < this.steps.length - 1) {
            this.currentStep++;
            this.onStepChange();
        }
    }

    goBack(): void {
        if (this.currentStep > 0) {
            this.currentStep--;
            this.onStepChange();
        } else if (this.mode === 'edit') {
            this.router.navigate(['/comptabilite/cheque-traite']);
        }
    }
    retour() {
        this.router.navigate(['/comptabilite/cheque-traite']);
    }

    isCurrentStepValid(): boolean {
        switch (this.currentStep) {
            case 0:
                return this.isStep1Valid;
            case 1:
                return this.isStep2Valid;
            case 2:
                return this.isStep3Valid;
            case 3:
                return this.isStep4Valid;
            case 4:
                return true;
            default:
                return false;
        }
    }

    validateStep1(): void {
        this.isStep1Valid = !!this.productData.type;
        this.showStep1Error = !this.isStep1Valid;
    }

    validateStep2(): void {
        this.isStep2Valid = !!this.productData.typePaiementStep || !!this.productData.typePaiement;
        this.showStep2Error = !this.isStep2Valid;
    }

    validateStep3(): void {
        this.isStep3Valid = this.step3Form?.valid !== false;
        this.cd.markForCheck();
    }

    validateStep4(): void {
        this.isStep4Valid = true;
    }

    validateStep5(): void {
        this.isStep5Valid = true;
    }

    togglePriceType(selectedValue: string): void {
        if (this.productData.priceType === selectedValue) {
            this.productData.priceType = '';
        } else {
            this.productData.priceType = selectedValue;
        }
        this.validateStep5();
    }

    onFileSelected(event: any): void {
        const file: File = event.target.files[0];

    }

    handleStepCompletion(stepIndex: number): void {

        if (stepIndex === 0) {
            this.validateStep1();
            if (this.isStep1Valid) {
                this.showStep1Error = false;
                this.nextStep();
            } else {
                this.showStep1Error = true;
            }
        }
        else if (stepIndex === 1) {
            this.validateStep2();
            if (this.isStep2Valid) {
                this.showStep2Error = false;
                this.nextStep();
            } else {
                this.showStep2Error = true;
            }
        }
        else if (stepIndex === 2) {
            this.validateStep3();
            if (this.isStep3Valid) this.nextStep();
        }
        else if (stepIndex === 3) {
            this.validateStep4();
            if (this.isStep4Valid) this.nextStep();
        } else if (stepIndex === 4) {
            this.validateStep5();
            if (this.isStep5Valid) {
                this.saveClient();
            }
        }
    }

    saveClient(): void {
        if (!this.stationId || !this.userId) {
            this.toastr.error('Données utilisateur manquantes', 'Erreur');
            return;
        }
        const typeOperation = this.productData.typeOperation || (this.productData.type === 'Materiel' ? 'emis' : 'recu');
        const typePaiement = this.productData.typePaiement || (this.productData.typePaiementStep === 'Materiel' ? 'cheque' : 'traite');

        if (!typeOperation || !typePaiement) {
            console.error('Données manquantes:', {
                typeOperation,
                typePaiement,
                productData: this.productData
            });
            this.toastr.error('Veuillez compléter tous les champs requis (type d\'opération et moyen de paiement)', 'Erreur');
            return;
        }

        if (!this.productData.paymentPeriodValue || this.productData.paymentPeriodValue <= 0) {
            this.toastr.error('Le montant doit être supérieur à 0', 'Erreur');
            return;
        }
        if (!this.stationId || !this.userId) {
            console.error('❌ [AddChequeComponent] Station ID ou User ID manquant:', {
                stationId: this.stationId,
                userId: this.userId
            });
            this.toastr.error('Données utilisateur manquantes. Veuillez vous reconnecter.', 'Erreur');
            return;
        }
        if (!this.productData.numero_cheque || this.productData.numero_cheque.trim() === '') {
            this.toastr.error('Le numéro de chèque/traite est obligatoire', 'Erreur');
            return;
        }
        if (!this.productData.date_reglement) {
            this.toastr.error('La date de paiement est obligatoire', 'Erreur');
            return;
        }
        // Calculer le montant avec le bon signe selon le type d'opération
        // Si "emis" -> montant négatif, si "recu" -> montant positif
        const montantAbsolu = this.productData.paymentPeriodValue || 0;
        const montantAvecSigne = typeOperation === 'emis' ? -Math.abs(montantAbsolu) : Math.abs(montantAbsolu);

        // Créer l'objet chèque/traite avec le montant signé
        const chequeTraite: any = {
            type_operation: typeOperation as 'emis' | 'recu',
            type: typePaiement as 'cheque' | 'traite',
            type_paiement: typePaiement as 'cheque' | 'traite',
            client_id: this.productData.client_id || this.clientId || null,
            montant: montantAvecSigne.toString(), // Montant avec signe : négatif pour emis, positif pour recu
            solde_type: this.productData.solde_type || 'secondaire',
            porteur: this.productData.porteur || null,
            banque_id: this.productData.banque_id || null,
            numero_cheque: this.productData.numero_cheque || null,
            numero_traite: typePaiement === 'traite' ? (this.productData.numero_cheque || null) : null,
            date_echeance: this.productData.date_echeance || null,
            date_paiement: this.productData.date_reglement || null,
            date_reglement: this.productData.date_reglement || null,
            note: this.productData.note || null,
            depuis: 'ajout', // Indiquer que le chèque/traite provient de l'ajout manuel
            statut: 'en_cours', // Statut par défaut pour les chèques/traites créés manuellement (format backend)
            station_id: this.stationId,
            user_id: this.userId
        };

        console.log('📝 [AddChequeComponent] Données complètes avant envoi:', {
            chequeTraite,
            stationId: this.stationId,
            userId: this.userId,
            hasStationId: !!this.stationId,
            hasUserId: !!this.userId
        });

        console.log('📝 [AddChequeComponent] Création chèque/traite:', chequeTraite);

        this.isLoading = true;
        
        // Créer uniquement le chèque/traite (sans opération de trésorerie)
        this.tresorerieService.createChequeTraite(chequeTraite).subscribe({
            next: (chequeTraiteResponse: any) => {
                this.isLoading = false;
                console.log('✅ [AddChequeComponent] Chèque/traite créé avec succès:', chequeTraiteResponse);
                if (chequeTraiteResponse && (chequeTraiteResponse.id || chequeTraiteResponse.success !== false)) {
                    this.toastr.success('Chèque/traite créé avec succès', 'Succès');
                    this.nextStep();
                } else {
                    const errorMsg = (chequeTraiteResponse as any)?.message || 'Erreur lors de la création du chèque/traite';
                    console.error('❌ [AddChequeComponent] Erreur création chèque/traite:', errorMsg);
                    this.toastr.error(errorMsg, 'Erreur');
                }
            },
            error: (error) => {
                this.isLoading = false;
                console.error('❌ [AddChequeComponent] Erreur lors de la création du chèque/traite:', error);
                const errorMessage = error?.error?.message || error?.message || 'Erreur lors de la création du chèque/traite';
                this.toastr.error(errorMessage, 'Erreur');
            }
        });
    }

    addNewCheque(): void {
        this.router.navigate(['/comptabilite/cheque-traite/ajout']).then(() => {
            window.location.reload();
        });
    }

    viewCheque(): void {
        this.router.navigate(['/comptabilite/cheque-traite']);
    }

    quickAdd(): void {

        if (this.isCurrentStepValid()) {
            this.saveClient();
            this.currentStep = this.steps.length - 1;
        } else {
            this.toastr.error('Veuillez remplir tous les champs requis', 'Erreur');
        }
    }

    toasterInfo(msg: any): void {
        this.toastr.info(msg, '', {
            positionClass: 'toast-top-right',
            toastClass: 'toast ngx-toastr',
            closeButton: true
        });
    }

    incrementPaymentPeriod(): void {
        this.productData.paymentPeriodValue = (this.productData.paymentPeriodValue || 1) + 1;
        this.validateStep4();
    }

    decrementPaymentPeriod(): void {
        if (this.productData.paymentPeriodValue > 1) {
            this.productData.paymentPeriodValue -= 1;
            this.validateStep4();
        }
    }

    openPriceModal(): void {
        this.newPriceName = '';
        this.newPriceValue = 0;
        this.showPriceModal = true;
    }

    closePriceModal(): void {
        this.showPriceModal = false;
    }

    confirmPrice(): void {
        if (this.newPriceName.trim() && this.newPriceValue >= 0) {
            const newPrice = {
                id: uuidv4(),
                name: this.newPriceName.trim(),
                value: this.newPriceValue
            };
            this.productData.customPrices.push(newPrice);
            this.productData.priceType = this.newPriceName.trim();
            this.closePriceModal();
            this.validateStep4();
        } else {
            this.toastr.info('Veuillez remplir le nom et une valeur valide du prix.', 'Information');
        }
    }

    cancelModal(): void {
        this.toastr.info('Action annulée', 'Information');
        this.isLoading = false;
        this.closePriceModal();
    }

    checkLengthOnce(): void {
        if (!this.showErrorOnce && this.newPriceName.length > 200) {
            this.showErrorOnce = true;

        } else if (this.newPriceName.length <= 200) {
            this.showErrorOnce = false;
        }
    }

    checkPriceValue(): void {
        if (this.newPriceValue < 0) {
            this.newPriceValue = 0;
        }
    }

    selectClientType(type: string): void {
        if (this.currentStep === 0) {
            this.productData.type = type;
            this.productData.typeOperation = type === 'Materiel' ? 'emis' : 'recu';
            this.validateStep1();
            if (this.isStep1Valid) {
                this.showStep1Error = false;
            }
        } else if (this.currentStep === 1) {
            this.productData.typePaiementStep = type;
            this.productData.typePaiement = type === 'Materiel' ? 'cheque' : 'traite';
            this.validateStep2();
            if (this.isStep2Valid) {
                this.showStep2Error = false;
            }
        } else if (this.currentStep === 3) {
            this.productData.solde_type = type === 'Materiel' ? 'secondaire' : 'primaire';
            this.validateStep4();
        }
        this.refreshFeatherIcons();
    }

    onStepChange(): void {
        if (this.currentStep === 4) {
            setTimeout(() => {
                this.initializeDatePickers();
            }, 100);
        }
    }

    selectAddressType(index: number, type: string): void {
        this.addressArray[index].addressType = type;
        this.validateStep3();
        this.refreshFeatherIcons();
    }
}
